<template>
    <svg
        class="ml-1 -mt-px"
        xmlns="http://www.w3.org/2000/svg"
        width="15.808"
        height="20.442"
        viewBox="0 0 15.808 20.442"
    >
        <path
            id="play"
            d="M0,.988V19.422a.964.964,0,0,0,.837,1,.7.7,0,0,0,.408-.136l0,0L15.367,11.1a1.138,1.138,0,0,0,0-1.8l0,0L1.243.115a.688.688,0,0,0-.4-.134A.964.964,0,0,0,0,.986v0Z"
            transform="translate(-0.001 0.019)"
            :class="fillClass + ' transition-fill'"
        />
    </svg>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "PlayIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
    },
});
</script>
